import type { FC } from 'react';
import { PurpleAlert } from '@gonfalon/launchpad-experimental/PurpleAlert';
import { toFlags } from '@gonfalon/navigator/navigators';
import { useProjectKey } from '@gonfalon/router/useProjectKey';
import { AlertText, Heading, LinkButton } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { trackSdkSetupNextStepsCTAClicked } from '../../analytics';

import styles from './SdkNextSteps.module.css';

interface SdkNextStepsProps {
  isActive: boolean;
}

export const SdkNextSteps: FC<SdkNextStepsProps> = ({ isActive }) => {
  const projectKey = useProjectKey();

  if (!isActive) {
    return null;
  }

  const handleNextStepsCTAClicked = () => {
    trackSdkSetupNextStepsCTAClicked();
  };

  return (
    <PurpleAlert actionsLayout="inline" className={styles.container}>
      <AlertText>
        <Heading className={styles.heading}>
          <Icon name="lightbulb" size="medium" className={styles.icon} />
          Recommended next step:
        </Heading>
      </AlertText>

      <LinkButton href={toFlags({ projectKey })} onPress={handleNextStepsCTAClicked}>
        Go to flags
        <Icon name="arrow-right-thin" size="small" />
      </LinkButton>
    </PurpleAlert>
  );
};
